export default class GetCoveragesBasicRequest {
  language: string
  coverages: { coverageCode: string }[]

  constructor(data: GetCoveragesBasicRequest) {
    this.language = data.language
    this.coverages = data.coverages
  }
}
